import { Actions, APIEndpoints, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, VuexModule, config } from "vuex-module-decorators";
import ApiService from "@/core/services/ApiService";

import {
  messaging,
  getToken,
  isSupported,
  firestoreDB,
  doc,
} from "@/firebase/init";
import { collection, getDoc, getDocs, updateDoc } from "firebase/firestore";
import axios from "axios";

config.rawError = true;

@Module
export default class FirebaseModule extends VuexModule {
  @Action({ rawError: true })
  [Actions.REQUEST_PERMISSION]() {
    return new Promise((resolve, reject) => {
      isSupported()
        .then((res) => {
          return Notification.requestPermission();
        })
        .then((permission) => {
          if (permission === "granted") {
            resolve("granted");
          } else {
            reject("denied");
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.GET_OR_REFRESH_FCM_TOKEN](payload) {
    return new Promise((resolve, reject) => {
      getToken(messaging, {
        vapidKey: process.env.VUE_APP_FIREBASE_VAPID_KEY,
      })
        .then((currentToken) => {
          resolve({
            hasPermission: currentToken ? true : false,
            token: currentToken,
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.GET_USERS_IN_FIREBASE]() {
    return new Promise((resolve, reject) => {
      getDocs(collection(firestoreDB, "Users"))
        .then((docs) => {
          resolve(docs);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.GET_USER_IN_FIREBASE](payload) {
    return new Promise((resolve, reject) => {
      const docRef = doc(firestoreDB, "Users", payload.userId);
      getDoc(docRef)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.UPDATE_FCM_TOKEN_IN_FIREBASE](payload) {
    return new Promise((resolve, reject) => {
      const updatedDoc = doc(firestoreDB, "Users", payload.userId);
      updateDoc(updatedDoc, payload.data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.VALIDATE_FCM_TOKEN](payload) {
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common["Authorization"] =
        "key=" + process.env.VUE_APP_FIREBASE_SERVER_KEY;
      axios.defaults.headers.common["Content-Type"] = "application/json";
      axios
        .post("https://fcm.googleapis.com/fcm/send", {
          registration_ids: [payload.fcmToken],
          dry_run: true,
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.GENERATE_FCM_ACCESS_TOKEN]() {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.get(`/${APIEndpoints.GENERATE_FIREBASE_TOKEN}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
}
